/**
 * Gift Price Filter Component
 * Integrates seamlessly with Shopify FacetFiltersForm for AJAX collection filtering
 */

// Global URL state change dispatcher
(function () {
  if (window._giftPriceBoxesHistoryPatched) return;
  window._giftPriceBoxesHistoryPatched = true;

  const pushState = history.pushState;
  const replaceState = history.replaceState;

  history.pushState = function () {
    const result = pushState.apply(this, arguments);
    window.dispatchEvent(new Event('giftpriceboxes:urlchange'));
    return result;
  };

  history.replaceState = function () {
    const result = replaceState.apply(this, arguments);
    window.dispatchEvent(new Event('giftpriceboxes:urlchange'));
    return result;
  };
})();

if (!customElements.get('gift-price-boxes')) {
  class GiftPriceBoxes extends HTMLElement {
    constructor() {
      super();
      this.handleUrlChange = this.handleUrlChange.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.handleUrlChange);
      window.removeEventListener('giftpriceboxes:urlchange', this.handleUrlChange);
    }

    init() {
      this.links = this.querySelectorAll('[data-gift-price-link]');
      this.items = this.querySelectorAll('.gift-price-boxes__item');

      this.links.forEach((link) => {
        link.addEventListener('click', this.handleCardClick.bind(this));
      });

      this.updateActiveState();

      window.addEventListener('popstate', this.handleUrlChange);
      window.addEventListener('giftpriceboxes:urlchange', this.handleUrlChange);
    }

    handleUrlChange() {
      this.updateActiveState();
    }

    handleCardClick(event) {
      const link = event.currentTarget;
      const item = link.closest('.gift-price-boxes__item');
      if (!item) return;

      const useCustomLink = item.getAttribute('data-use-custom-link') === 'true';
      if (useCustomLink) {
        return; // Allow standard link navigation
      }

      // Check if we are on a collection page with AJAX facet filtering
      const hasProductGrid = document.getElementById('product-grid') && document.getElementById('ProductGridContainer');
      const hasFacetForm = typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderPage === 'function';

      // Check if target link is for the current pathname
      let targetUrl;
      try {
        targetUrl = new URL(link.getAttribute('href'), window.location.origin);
      } catch (err) {
        return;
      }

      const isCurrentPath = targetUrl.pathname === window.location.pathname;

      if (hasProductGrid && hasFacetForm && isCurrentPath) {
        event.preventDefault();

        const isAll = item.getAttribute('data-is-all') === 'true';
        const maxPrice = item.getAttribute('data-max-price');
        const minPrice = item.getAttribute('data-min-price') || '0';

        // Prepare new URLSearchParams based on current query string
        const currentParams = new URLSearchParams(window.location.search);

        // Remove pagination so user lands on first page
        currentParams.delete('page');

        // Remove previous price filter parameters
        currentParams.delete('filter.v.price.gte');
        currentParams.delete('filter.v.price.lte');

        // If not 'All Gifts', apply the selected price threshold
        if (!isAll && maxPrice) {
          const cleanMax = String(maxPrice).replace(/[$,]/g, '').trim();
          const cleanMin = String(minPrice).replace(/[$,]/g, '').trim();

          if (cleanMin && parseFloat(cleanMin) > 0) {
            currentParams.set('filter.v.price.gte', cleanMin);
          } else {
            currentParams.set('filter.v.price.gte', '0');
          }
          currentParams.set('filter.v.price.lte', cleanMax);
        }

        // Set visual active state immediately
        this.setActiveItem(item);

        const newSearchString = currentParams.toString();

        // AJAX update using theme's native FacetFiltersForm
        FacetFiltersForm.renderPage(newSearchString);
      }
    }

    updateActiveState() {
      const searchParams = new URLSearchParams(window.location.search);
      const urlMaxPrice = searchParams.get('filter.v.price.lte');

      let matchedItem = null;

      if (urlMaxPrice !== null && urlMaxPrice !== '') {
        const parsedUrlMax = parseFloat(urlMaxPrice.replace(/[$,]/g, ''));

        this.items.forEach((item) => {
          const isAll = item.getAttribute('data-is-all') === 'true';
          const maxPrice = item.getAttribute('data-max-price');

          if (!isAll && maxPrice) {
            const parsedItemMax = parseFloat(String(maxPrice).replace(/[$,]/g, ''));
            if (!isNaN(parsedItemMax) && Math.abs(parsedUrlMax - parsedItemMax) < 0.01) {
              matchedItem = item;
            }
          }
        });
      }

      // If no matching price box found or no price filter in URL, activate 'All' box
      if (!matchedItem) {
        this.items.forEach((item) => {
          if (!matchedItem) {
            const isAll = item.getAttribute('data-is-all') === 'true';
            const maxPrice = item.getAttribute('data-max-price');
            if (isAll || !maxPrice) {
              matchedItem = item;
            }
          }
        });
      }

      if (matchedItem) {
        this.setActiveItem(matchedItem);
      }
    }

    setActiveItem(activeItem) {
      this.items.forEach((item) => {
        if (item === activeItem) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });
    }
  }

  customElements.define('gift-price-boxes', GiftPriceBoxes);
}

// Support Shopify Theme Customizer events
document.addEventListener('shopify:section:load', (event) => {
  const element = event.target.querySelector('gift-price-boxes');
  if (element && typeof element.init === 'function') {
    element.init();
  }
});

document.addEventListener('shopify:block:select', (event) => {
  const blockItem = event.target.closest('.gift-price-boxes__item');
  if (blockItem) {
    const parent = blockItem.closest('gift-price-boxes');
    if (parent && typeof parent.setActiveItem === 'function') {
      parent.setActiveItem(blockItem);
    }
  }
});

